<!-- Draws a heap with values from 0 to 9 -->
<script>
export let n = 5;
// export let size = 3;
export let base_color_face="white";
export let base_color_dot="black";
export let bg_opacity=.9;
export let width = 160;
export let height = 160;
let radius = 18;
</script>
<svg width={width} height={height} viewBox="0 0 150 150">
  <rect x="5" y="5" rx="20" ry="20" width="140" height="140" fill={base_color_face} fill-opacity={bg_opacity}/>
	{#if n==9}
	 <circle cx="32" cy="32" r={radius} fill={base_color_dot} />
	 <circle cx="32" cy="75" r={radius}   fill={base_color_dot}/>
	 <circle cx="118" cy="75" r={radius}   fill={base_color_dot}/>
	 <circle cx="32" cy="118" r={radius}  fill={base_color_dot} />
	 <circle cx="118" cy="32" r={radius}  fill={base_color_dot} />
	 <circle cx="75" cy="75" r={radius}  fill={base_color_dot}/>
	 <circle cx="118" cy="118" r={radius}  fill={base_color_dot}/>
	 <circle cx="75" cy="32" r={radius}  fill={base_color_dot}/>
	 <circle cx="75" cy="118" r={radius}  fill={base_color_dot}/>
	{:else if n==8}
	 <circle cx="32" cy="32" r={radius} fill={base_color_dot} />
	 <circle cx="32" cy="75" r={radius}   fill={base_color_dot}/>
	 <circle cx="118" cy="75" r={radius}   fill={base_color_dot}/>
	 <circle cx="32" cy="118" r={radius}  fill={base_color_dot} />
	 <circle cx="118" cy="32" r={radius}  fill={base_color_dot} />
	 <circle cx="75" cy="75" r={radius}  fill={base_color_dot}/>
	 <circle cx="118" cy="118" r={radius}  fill={base_color_dot}/>
	 <circle cx="75" cy="118" r={radius}  fill={base_color_dot}/>
	{:else if n==7}
	 <circle cx="75" cy="75" r={radius} fill={base_color_dot} />
	 <circle cx="32" cy="75" r={radius}   fill={base_color_dot}/>
	 <circle cx="118" cy="75" r={radius}   fill={base_color_dot}/>
	 <circle cx="32" cy="118" r={radius}  fill={base_color_dot} />
	 <circle cx="118" cy="32" r={radius}  fill={base_color_dot} />
	 <circle cx="118" cy="118" r={radius}  fill={base_color_dot}/>
	 <circle cx="75" cy="118" r={radius}  fill={base_color_dot}/>
	{:else if n==6}
	 <circle cx="75" cy="118" r={radius} fill={base_color_dot} />
	 <circle cx="32" cy="75" r={radius}   fill={base_color_dot}/>
	 <circle cx="118" cy="75" r={radius}   fill={base_color_dot}/>
	 <circle cx="32" cy="118" r={radius}  fill={base_color_dot} />
	 <circle cx="75" cy="75" r={radius}  fill={base_color_dot} />
	 <circle cx="118" cy="118" r={radius}  fill={base_color_dot}/>
	{:else if n==5}
	 <circle cx="32" cy="75" r={radius} fill={base_color_dot} />
	 <circle cx="32" cy="118" r={radius}  fill={base_color_dot} />
	 <circle cx="118" cy="75" r={radius}  fill={base_color_dot} />
	 <circle cx="75" cy="118" r={radius}  fill={base_color_dot}/>
	 <circle cx="118" cy="118" r={radius}  fill={base_color_dot}/>
	{:else if n==4}
	 <circle cx="75" cy="118" r={radius} fill={base_color_dot} />
	 <circle cx="32" cy="118" r={radius}  fill={base_color_dot} />
	 <circle cx="118" cy="75" r={radius}  fill={base_color_dot} />
	 <circle cx="118" cy="118" r={radius}  fill={base_color_dot}/>
	{:else if n==3}
	 <circle cx="32" cy="118" r={radius} fill={base_color_dot} />
	 <circle cx="75" cy="118" r={radius}  fill={base_color_dot}/>
	 <circle cx="118" cy="118" r={radius}  fill={base_color_dot}/>
	{:else if n==2}
	 <circle cx="75" cy="118" r={radius} fill={base_color_dot} />
	 <circle cx="118" cy="118" r={radius}  fill={base_color_dot}/>
	{:else if n==1}
	 <circle cx="75" cy="118" r={radius}  fill={base_color_dot}/>
	{/if}
</svg>
<style>
	rect{
 stroke:black;
stroke-width:5;
		opacity:.9;
	}
	circle{
stroke:black;
stroke-width:0;
		opacity:1;
	}
</style>